import { useEffect, useState } from 'react';

import Base from '../../../utils/base'
import CustomTable from '../../../layout/custom_table/index'

export default function City() {
  var base = new Base()
  const [arr_header, set_arr_header] = useState([
    {
      label: base.i18n.t('name'),
      data: 'name',
    },
    {
      label: base.i18n.t('province'),
      data: 'province_name',
    },
    {
      label: base.i18n.t('country'),
      data: 'country_name',
    },
  ])
  const [arr, set_arr] = useState([])

  function on_update_data(arr){
    arr.forEach((data, index) => {
      data.province_name = data.province.name
      data.country_name = data.province.country.name
    })
    set_arr(arr)
  }

  return (
    <div>
      <h3>{base.i18n.t('city')}</h3>
      <CustomTable 
        url='/city' 
        arr_header={arr_header} 
        arr={arr} 
        url_update='/city/action'
        url_create='/city/action'
        url_delete='/city'
        on_update_data={data => on_update_data(data)}/>
    </div>
  );
}